import { render, staticRenderFns } from "./Pension-Fund.vue?vue&type=template&id=2ac5e436&scoped=true"
import script from "./Pension-Fund.vue?vue&type=script&lang=js"
export * from "./Pension-Fund.vue?vue&type=script&lang=js"
import style0 from "./Pension-Fund.vue?vue&type=style&index=0&id=2ac5e436&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac5e436",
  null
  
)

export default component.exports